import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import VideoConferenceModal from '../FaceTalk';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function RoomWithAuth() {
  const { roomId } = useParams();
  const query = useQuery();
  const token = query.get('token');
  const [authState, setAuthState] = useState('loading');
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!token) {
      // 토큰 없이 직접 접속한 경우 - 세션 확인 후 허용
      setAuthState('authenticated');
      return;
    }

    // 토큰 검증
    fetch(`/api/room/validate-token?token=${encodeURIComponent(token)}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setUser(data.user);
          setAuthState('authenticated');
          // SocketContext에서 사용할 수 있도록 저장
          sessionStorage.setItem('user', JSON.stringify(data.user));
        } else {
          setAuthState('error');
        }
      })
      .catch(() => setAuthState('error'));
  }, [token]);

  if (authState === 'loading') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#1a1a2e' }}>
        <p style={{ color: '#fff', fontSize: '18px' }}>연결 중...</p>
      </div>
    );
  }

  if (authState === 'error') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#1a1a2e', flexDirection: 'column' }}>
        <p style={{ color: '#ff6b6b', fontSize: '18px' }}>인증에 실패했습니다.</p>
        <p style={{ color: '#aaa', fontSize: '14px' }}>링크가 만료되었거나 유효하지 않습니다.</p>
      </div>
    );
  }

  return <VideoConferenceModal isOpen={true} roomId={roomId} onClose={() => window.close()} />;
}

export default RoomWithAuth;
